export const MAP_REGISTRY_SCHEMA = 'csgo2-radar/map-registry/v1';

export function normalizeMapId(value) {
  const raw = String(value ?? '').trim().toLowerCase().replaceAll('\\', '/');
  const match = raw.match(/(?:^|\/)(de_[a-z0-9_]+)(?:\.[a-z0-9]+)?(?:$|\/)/)
    || raw.match(/(de_[a-z0-9_]+)/);
  return match ? match[1] : raw.replace(/^dynamic_/, '').replace(/^maps\//, '');
}

export function validateRegistry(registry) {
  if (registry?.schema !== MAP_REGISTRY_SCHEMA || registry?.gameId !== 'csgo2') {
    throw new Error('CS2RADAR-REGISTRY-002: invalid map registry');
  }
  const ids = new Set();
  for (const entry of registry.maps || []) {
    const mapId = normalizeMapId(entry.mapId);
    if (!mapId || ids.has(mapId)) throw new Error('CS2RADAR-REGISTRY-003: duplicate or empty map id');
    ids.add(mapId);
  }
  return registry;
}

export function findMapEntry(registry, mapId) {
  const normalized = normalizeMapId(mapId);
  return registry?.maps?.find((entry) => normalizeMapId(entry.mapId) === normalized) || null;
}
